import { LoadingIcon as LoadingDs, Typography } from "@packages/ds";
import styled, { keyframes } from "styled-components";

import { CloseButton } from "ds/Button";
import * as Dropdown from "ds/Dropdown";
import Search, { Icon, Close } from "ds/Search";
import { Search as SearchPrimitive } from "ds/Search/Search.styles";
import { semiBoldAlias } from "Libs/theme";

export const Layout = styled.div`
  .header-arrow + .header-arrow {
    border-top: 1px solid #d8e2ef;
  }
`;

export const CloseWindow = styled(CloseButton)`
  float: right;
  margin-top: -4px;
  margin-right: -4px;
`;
const expandOut = keyframes`
  0% {
    width: 68px;
  }
  100% {
    width: 176px;
  }
`;

const expandIn = keyframes`
  0% {
    width: 176px;
  }
  100% {
    width: 68px;
  }
`;

export const FiltersDiv = styled.div`
  display: flex;
  align-items: center;
  .info-button > button {
    &.open svg {
      transform: none;
    }
    span.icon svg rect {
      fill: var(--icon-slate-fill, var(--slate));
    }
  }

  .select-box__control {
    background: transparent;
  }

  label {
    color: var(--section-slate-color, var(--slate));
  }

  .search-wrapper {
    height: inherit;
    display: none;
    input.search {
      width: 86px;
      animation: ${expandIn} 0.18s linear 1;
      padding: 0 8px 0 32px;
      &.active {
        width: 176px;
        animation: ${expandOut} 0.18s linear 1;
      }
    }
  }

  @media (min-width: 580px) {
    .search-wrapper {
      display: inline-block;
    }
  }
`;

export const EmptyWrapper = styled.div`
  text-align: center;
  margin: 96px 0 130px 0;
  width: 100%;
  h2 {
    margin-bottom: 16px;
  }
  p {
    color: var(--section-ebony-color, var(--ebony));
    font-size: 14px;
    width: 432px;
    max-width: 100%;
    margin: 0 auto 40px;
  }
  span.create-project {
    display: inline-block;
    margin-bottom: 170px;
  }
`;

export const EmptyImage = styled.div`
  margin: 0 auto 48px;
  width: 156px;
  svg {
    max-width: 100%;
    height: auto;
  }
`;

export const PlansHeaderWrapper = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const IconFilterWrapper = styled.span`
  margin-top: 2px;
  color: var(--section-slate-color, var(--slate));
  &:hover {
    color: var(--section-color-primary-600-color, var(--color-primary-600));
  }
`;

export const FilterDropdownLabel = styled(Dropdown.Label)`
   {
    font-size: 13px;

    color: var(--section-granite-color, var(--granite));
    ${semiBoldAlias()};
    &.title {
      line-height: 24px;
      color: green;
    }

    .checkbox-field,
    .checkbox-field label {
      margin: 0;
    }
    .checkbox-field {
      margin-bottom: 8px;
      &.checked {
        label {
          color: var(
            --section-color-primary-600-color,
            var(--color-primary-600)
          );
        }
      }
    }
    .radio-field {
      &.checked {
        label {
          color: var(
            --section-color-primary-600-color,
            var(--color-primary-600)
          );
        }
      }
    }
    .search-wrapper {
      height: inherit;
      margin-right: 8px;
      display: none;
      input.search {
        width: 86px;
        animation: ${expandIn} 0.18s linear 1;
        padding: 0 8px 0 32px;
        &.active {
          animation: ${expandOut} 0.18s linear 1;
        }
      }
    }
    .environments-filter-window {
      width: 300px;
      right: 50%;
      margin-right: -143px;

      h6 {
        font-size: 14px;
        color: var(--section-ebony-light-color, var(--ebony-light));
        ${semiBoldAlias()};
        &.title {
          font-weight: bold;
          line-height: 24px;
        }
      }

      .radio-field:last-child label,
      .radio-field:last-child {
        margin-bottom: 0;
      }
    }
    .info-button {
      > button {
        padding: 0 4px !important;
        border: none;
        width: auto;
        margin-right: 16px;
        @media (min-width: 1280px) {
          width: 70px;
        }
        &:hover,
        &.open {
          svg {
            transform: none;
            rect {
              fill: var(
                --icon-color-primary-600-fill,
                var(--color-primary-600)
              );
            }
          }
        }
      }
      .text {
        display: none;
        @media (min-width: 1280px) {
          display: inline-block;
        }
      }
    }
    @media (min-width: 580px) {
      .search-wrapper {
        display: inline-block;
      }
    }
    @media (min-width: 900px) and (max-width: 1000px) {
      width: 50%;
      .checkbox-field {
        margin-bottom: 8px;
      }
    }

    #radix-2 {
      padding-top: 2px;
      > ${IconFilterWrapper} {
        padding: 0 4px !important;
        border: none;
        width: auto;
        margin-right: 16px;

        @media (min-width: 1280px) {
          width: 70px;
        }
      }
      .text {
        display: none;
        @media (min-width: 1280px) {
          display: inline-block;
        }
      }
    }
    @media (min-width: 580px) {
      .search-wrapper {
        display: inline-block;
      }
    }
    @media (min-width: 900px) and (max-width: 1000px) {
      width: 50%;
      .checkbox-field {
        margin-bottom: 8px;
      }
    }
  }
`;

export const FragmentLabel = styled.h6`
  font-size: 14px;
  margin: 0px;

  & > ${FilterDropdownLabel} {
    padding-top: 8px;
    color: var(--section-granite-color, var(--granite));
    ${semiBoldAlias()};

    ${({ isMainLabel }) =>
      isMainLabel &&
      `
        padding-top: 8px;
        padding-bottom: 0;
        font-weight: 600;
        line-height: 24px;
    `}
  }
`;

export const Title = styled(Typography.Title)`
  margin-bottom: 32px;
`;

export const NoProjectPlansTitle = styled(Typography.Title)`
  margin-bottom: 16px;
`;

export const SearchInput = styled(Search)`
  min-width: 100px;
  ${Close} svg {
    display: none;
  }

  :has(${SearchPrimitive}:focus) {
    ${Icon} {
      fill: var(--mode-vector-neutral-strong);
    }
  }

  ${SearchPrimitive} {
    padding-left: 5px;
    &::placeholder {
      font-size: 14px;
      line-height: 24px;
      color: var(--mode-text-neutral-default-weak);
    }

    &:focus {
      &::placeholder {
        color: var(--mode-text-neutral-weakest);
      }
    }
  }

  ${Icon} {
    fill: var(--mode-vector-neutral-default);
  }
`;

export const Loading = styled(LoadingDs)`
  display: flex;
  margin: 10px auto 0 auto;
`;
